import { useMutation, useQueryClient } from '@tanstack/react-query';

import { UserDataClient } from '@app/client';
import { UserDataKey } from '@app/client/common/structs/user/user-data';
import { callSetUserData, type SetUserDataParams } from '@app/client/resources/admin/users';
import { type FeatureFlags } from '@app/store/types/features';

export const useSetUserFeatures = () => {
    const client = useQueryClient();
    const onSuccess = () => client.invalidateQueries({ queryKey: ['user-features'] });
    const onError = (e) => alert(e);
    const key = UserDataKey.FrontendFeatureFlags;
    return useMutation({
        mutationFn: ({ id, value }: Omit<SetUserDataParams, 'key'>) => callSetUserData({ key, id, value }),
        onSuccess,
        onError,
    });
};

// TODO make more re-usable
export const useUserSetFeatures = () => {
    const client = useQueryClient();
    const onSuccess = () => client.invalidateQueries({ queryKey: ['user-features'] });
    const key = UserDataKey.FrontendFeatureFlags;
    return useMutation({
        mutationFn: (value: FeatureFlags) => UserDataClient.putUserData({ key, value: { value } }),
        onSuccess,
    });
};
